import { memo } from 'react';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import type { Slug, UrlFriendlySlug } from '@bridebook/toolbox/src/types';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { getFacetFilterInText } from '@bridebook/web/app-shared/lib/search/quick-filter-texts';
import { isCountryLevelSearch } from '@bridebook/web/app-shared/lib/search/utils/format-area';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';
import { formatAreaWithCountry, getLocationInfoPhrasing } from '@bridebook/web/lib/search/utils';
import formatArea from '@bridebook/web/lib/search/utils/format-prediction-area';
import type { SearchResponseFields } from '@bridebook/web/lib/search/types';

interface IProps {
  fields: SearchResponseFields;
  actualCategory: Slug | UrlFriendlySlug;
  facetTitle?: string;
  facetsParams?: string[];
}

const SearchInfoHeader = ({ actualCategory, fields, facetsParams, facetTitle }: IProps) => {
  const market = useMarket();
  const { area } = fields;

  const facet = facetsParams?.[0];
  const supplierType = facet ? getFacetFilterInText(facet) : '';
  const text = (() => {
    const prettyCategory = prettySupplierCategory({
      isLoggedIn: false,
      slug: actualCategory,
      amount: 2,
      addWedding: true,
      capitalize: true,
      market,
    });

    if (market.country === CountryCodes.FR) {
      return [prettyCategory, formatArea(area)].filter(Boolean).join(': ');
    }

    const processedArea = isCountryLevelSearch(area, market.country, market.alias)
      ? area.toUpperCase()
      : area;

    return [
      supplierType,
      prettyCategory,
      getLocationInfoPhrasing(processedArea, false),
      formatAreaWithCountry(formatArea(processedArea), market),
    ]
      .filter(Boolean)
      .join(' ');
  })();

  return (
    <h1 className="bsheading" data-name="results-heading">
      {facetTitle || text}
    </h1>
  );
};

export default memo(SearchInfoHeader);
